<template>
  <page-option overflow-hidden>
    <template #title>
      <v-avatar color="#E3FCF7" size="35">
        <v-icon color="#108F6E" size>mdi-code-tags</v-icon>
      </v-avatar>
      <div class="pl-2 title-page"> {{ $t('sidebar.symbol.name') }}</div>
    </template>
    <v-row>
      <v-col
        class="d-flex flex-column card-container"
        cols="6"
        lg="6"
        md="6"
        order-sm="1"
        sm="12"
        xl="6"
      >
        <v-card
          outlined
          hover
          class="mr-12 mt-2 font-card"
          @click="goSymbol('/ky-hieu-ban-do/symbol')"
        >
          <v-card-header>
            <div class="text-overline mb-4 ml-4 text-header"> ICON </div>
            <v-divider class="mx-1"></v-divider>
          </v-card-header>
          <v-list-item three-line>
            <v-avatar color="#F4F7FA" size="120" class="mt-3 mr-3">
              <v-img src="/static/img/ggmap_img.jpg"> </v-img>
            </v-avatar>
            <v-list-item-content>
              <v-list-item-title class="text-h5 mb-1">
                Ký hiệu bản đồ
              </v-list-item-title>
              <v-list-item-subtitle class="pt-1">
                Tập hợp các ký hiệu hình ảnh sử dụng trên nền bản đồ
              </v-list-item-subtitle>
              <div class="d-flex pt-3">
                <div class="pr-4">{{ symbolInfo.icon_count || 0 }} icon</div>
                <div>{{ getFileSize(symbolInfo.icon_size) }} </div>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col
        class="d-flex flex-column card-container"
        cols="6"
        lg="6"
        md="6"
        order-sm="1"
        sm="12"
        xl="6"
      >
        <v-card
          outlined
          hover
          class="mt-2 font-card"
          @click="goSymbol('/ky-hieu-ban-do/fonts')"
        >
          <v-card-header>
            <div class="text-overline mb-4 ml-4 text-header"> Phông chữ </div>
            <v-divider class="mx-4"></v-divider>
          </v-card-header>
          <v-list-item three-line>
            <v-avatar color="#F4F7FA" size="120" class="mt-3 mr-3">
              <v-img src="/static/img/font_img.jpg"> </v-img>
            </v-avatar>
            <v-list-item-content>
              <v-list-item-title class="text-h5 mb-1">
                Phông chữ bản đồ
              </v-list-item-title>
              <v-list-item-subtitle class="pt-1"
                >Danh sách các Phông chữ trên nền bản đồ</v-list-item-subtitle
              >
              <div class="d-flex pt-3">
                <div class="pr-4"
                  >{{ symbolInfo.font_count || 0 }} phông chữ</div
                >
                <div>{{ getFileSize(symbolInfo.font_size) }}</div>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
  </page-option>
</template>

<script>
import { API_SYMBOL } from '@api'
export default {
  data: () => ({
    symbolInfo: {},
  }),
  mounted() {
    this.getInfo()
  },
  methods: {
    goSymbol(link) {
      this.$router.push(link)
    },
    async getInfo() {
      let data = await API_SYMBOL.getSymbolInfo()
      this.symbolInfo = data.data.data
    },
    getFileSize(size) {
      if (!size) return `0 Kb`
      try {
        let sizeKb = size / 1024
        if (sizeKb < 1024) {
          return sizeKb.toFixed(1) + ' Kb'
        } else {
          return (sizeKb / 1024).toFixed(1) + ' Mb'
        }
      } catch (error) {
        return ''
      }
    },
  },
}
</script>

<style>
.font-card {
  border-radius: 8px;
  width: 100%;
  height: 190px;
}
.text-header {
  height: 20px;
  left: 19px;
  top: 9px;

  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  /* identical to box height, or 167% */

  letter-spacing: 0.25px;
  text-transform: uppercase;
}
</style>
